export enum LineWidth {
  THIN = 0.2,
  NORMAL = 0.4,
  THICK = 0.6,
}
